import { initialArticleEditState } from 'mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.constants';
import { ArticleEditState } from 'mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.reducers';
import { AppState } from 'mk2/reducers';

export const getArticleEditState = (state: AppState, username: string, articleSlug: string): ArticleEditState =>
    state.containers.blogs.blogsArticleEdits[`${username}/${articleSlug}`] || initialArticleEditState;
